const projectsData = [
    {
        title: 'Tingg Payments Gateway',
        description: 'I was part of the team that developed the payments gateway during my time at Cellulant. With Tingg, you can collect and make payments from anywhere in Africa.',
        image: 'https://d2fcmuoyu5hsuu.cloudfront.net/tingg.png',
        technologies: ['Java 11', 'Angular 12', 'MySQL', 'Kubernetes', 'AWS', 'Agile'],
        liveLink: 'https://tingg.africa/'
    }, {
        title: 'Pilim',
        description: 'I was part of the team that developed the business management tool at S-Mobile. With Pilim, you can automate your business processes, reducing the operational workload by at least 30%.',
        image: 'https://d2fcmuoyu5hsuu.cloudfront.net/pilim.png',
        technologies: ['Java 21', 'Angular 14', 'MySQL', 'PostgreSQL', 'Kubernetes', 'AWS', 'Python', 'Agile'],
        liveLink: 'https://www.pilim.net/'
    }, {
        title: 'Intellommerce.ai',
        description: 'A personal project; Intellommerce is an AI-driven digital transformation platform.',
        image: 'intellommerce.jpg',
        technologies: ['Python', 'React', 'AWS', 'LLM', 'RAG'],
        liveLink: 'https://intellommerce.ai/'
    }, {
        title: 'EcoSure',
        description: 'I was part of the team that developed the funeral insurance system at Ecocash Holdings. With EcoSure, you can insure yourself as well as your immediate and extended family members in case of death.',
        image: 'https://d2fcmuoyu5hsuu.cloudfront.net/ecosure.jpg',
        technologies: ['Java 8', 'Spring Boot', 'AngularJS', 'MySQL', 'Scrum'],
        liveLink: 'https://www.ecosure.co.zw/'
    }
];

export default projectsData;